import { useState, useEffect } from 'react';

export default function useThema() {
  const [tema, setTema] = useState(() => {
    const salvo = localStorage.getItem('tema');
    if (salvo === 'dark' || salvo === 'light') return salvo;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', tema);
    localStorage.setItem('tema', tema);
  }, [tema]);

  function alternarTema() {
    setTema(t => (t === 'light' ? 'dark' : 'light'));
  }

  return { tema, alternarTema };
}
